/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".share-iframe[_ngcontent-%COMP%]{width:100%;min-height:450px}@media (min-width:592px){.share-iframe[_ngcontent-%COMP%]{min-height:490px}}@media (min-width:992px){.share-iframe[_ngcontent-%COMP%]{min-height:500px}}"];
export { styles as styles };
//# sourceMappingURL=share-certificate-iframe.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/components/share-certificate-iframe/share-certificate-iframe.component.scss.shim.ngstyle.js
// module id = 1391
// module chunks = 27 28 29